<div class="page-content">
    <div class="content-header">
        <span class="title">Checkout</span>
        <div class="actions">
            <button
                mat-button
                [disableRipple]="true"
                color="primary"
                (click)="goBack()"
                qa="edit-gift-card-button"
            >
                Edit Gift Card
            </button>
        </div>
    </div>
    <div class="content-body">
        <ols-summary class="content-box" [summary]="summary"> </ols-summary>
        <ols-payment-information
            class="content-box"
            [purchaseAgreement]="purchaseAgreement"
            [isLoading]="isLoading"
            [stripeSurchargeSettings]="stripeSurchargeSettings"
            [summary]="summary"
        >
        </ols-payment-information>
    </div>
    <div class="content-footer">
        <button
            mat-stroked-button
            (click)="goBack()"
            qa="back-button"
            class="back-button"
            [disabled]="isLoading || isCheckingOut"
        >
            Back
        </button>
        <button
            mat-flat-button
            color="primary"
            (click)="submitForm()"
            qa="purchase-button"
            class="purchase-button"
            [disabled]="isLoading || isCheckingOut"
        >
            <span> Purchase Now</span>
        </button>
    </div>
</div>
